<template>
  <div
    v-if="price"
    class="absolute rounded-full bg-black text-white top-4 right-4 overflow-hidden flex flex-col items-center h-20 w-20 md:h-32 md:w-32 z-10"
  >
    <span class="text-center items-center h-full w-full flex justify-center fluid-lg font-light leading-normal">
      {{
        $n(parseFloat(price), {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
        })
      }}
    </span>
    <span
      v-if="compareAtPrice"
      class="fluid-xs leading-tightest line-through absolute bottom-4 md:bottom-7"
      data-test-id="price"
    >
      {{
        $n(parseFloat(compareAtPrice), {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
        })
      }}
    </span>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    price: {
      type: String,
      default: null,
    },
    compareAtPrice: {
      type: String,
      default: null,
    },
    currency: {
      type: String,
      required: true,
    },
  },
});
</script>
